/**
 * Formats a seat's occurrence as the Session's own wall-clock date and time. The wire
 * values are already local to the Session's zone, so they are read as UTC parts and
 * printed with `timeZone: "UTC"` — the clock shown is the Session's, never the viewer's.
 */
const wallClock = (date: string, time?: string): Date => {
  const [y, m, d] = date.split("-").map(Number);
  const [hh, mm] = (time ?? "00:00").split(":").map(Number);
  return new Date(Date.UTC(y, m - 1, d, hh, mm));
};

export const formatSeatDate = (date: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, { weekday: "short", day: "numeric", month: "long", timeZone: "UTC" }).format(
    wallClock(date),
  );

/** Short weekday, day and month ("Tue, 28 Oct"), the Session's own wall-clock date. */
export const formatSeatShortDate = (date: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" }).format(
    wallClock(date),
  );

export const formatSeatDateTime = (date: string, time: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    timeZone: "UTC",
  }).format(wallClock(date, time));
